import React, { memo } from 'react';
import { Stack, Typography, LinearProgress } from 'investira.react.components';
import { validators } from 'investira.sdk';

const AvaliacoesProgresso = memo(props => {
  const {
    variant = null,
    qtdQuestoes = 0,
    qtdQuestoesRespondiveis = qtdQuestoes,
    respondidas = 0,
    revisadas = 0
  } = props;
  const xRespondidasProgress = qtdQuestoesRespondiveis
    ? (respondidas / qtdQuestoesRespondiveis) * 100
    : 0;
  const xRevisadasProgress = qtdQuestoes ? (revisadas / qtdQuestoes) * 100 : 0;
  return (
    <Stack gap={1}>
      <Stack flex={1}>
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ textTransform: 'uppercase', fontWeight: 500 }}>
          Questões
        </Typography>
      </Stack>

      <Stack direction="row" gap={2}>
        <Stack flex={1}>
          <Typography variant="caption" color="textPrimary">
            Respondidas
          </Typography>
          <Typography variant="h6" color="textPrimary">
            {respondidas}/{qtdQuestoesRespondiveis}
          </Typography>
          <LinearProgress
            variant="determinate"
            value={xRespondidasProgress}
            color={!validators.isNull(variant) ? 'primary' : 'info'}
          />
        </Stack>
        {validators.isNull(variant) && (
          <Stack flex={1}>
            <Typography variant="caption" color="textPrimary">
              Vistos
            </Typography>
            <Typography variant="h6" color="textPrimary">
              {revisadas}/{qtdQuestoes}
            </Typography>
            <LinearProgress variant="determinate" value={xRevisadasProgress} />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
});

export default AvaliacoesProgresso;
